import {
  Injectable,
  ApplicationRef,
  Injector,
  ComponentRef,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { ScaffoldSidebarFrameComponent } from './scaffold-sidebar-frame/scaffold-sidebar-frame.component';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ScaffoldSidebarService {
  private modalComponentRefs: ComponentRef<ScaffoldSidebarFrameComponent>[] =
    [];

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  defaultConfig: any = {
    hasBackdrop: false,
    closeOnBackdropClick: false,
    hasScroll: true,
    context: null,
  };

  open(component: Type<any>, config?: any) {
    if (!config) {
      config = this.defaultConfig;
    } else {
      config = { ...this.defaultConfig, ...config };
    }
    document.body.classList.add('modal-open');
    const rootViewContainerRef =
      this.appRef.components[0].injector.get(ViewContainerRef);
    const modalComponentRef = rootViewContainerRef.createComponent(
      ScaffoldSidebarFrameComponent,
      { injector: this.injector }
    );
    modalComponentRef.instance.settings = config;
    const scaffoldSidebarRef = new ScaffoldSidebarRef(modalComponentRef, this);
    scaffoldSidebarRef.settings = config;
    const modalContentViewContainerRef =
      modalComponentRef.instance.viewContainerRef;
    const injector = Injector.create({
      providers: [
        { provide: ScaffoldSidebarRef, useValue: scaffoldSidebarRef },
      ],
      parent: this.injector,
    });
    const modalContentComponentRef =
      modalContentViewContainerRef.createComponent(component, {
        injector: injector,
      });
    if (config.context) {
      (modalContentComponentRef.instance as any).data = config.data;
      for (const key in config.context) {
        if (config.context.hasOwnProperty(key)) {
          (modalContentComponentRef.instance as any)[key] = config.context[key];
        }
      }
    }
    scaffoldSidebarRef.componentRef = modalContentComponentRef;
    modalComponentRef.instance.closed.subscribe(() => {
      this.close(modalComponentRef);
    });
    this.modalComponentRefs.push(modalComponentRef);
    return scaffoldSidebarRef;
  }

  close(modalComponentRef: ComponentRef<ScaffoldSidebarFrameComponent>): void {
    this.appRef.detachView(modalComponentRef.hostView);
    this.modalComponentRefs = this.modalComponentRefs.filter(
      ref => ref !== modalComponentRef
    );
    modalComponentRef.destroy();
    if (this.findBackdropModalCount() === 0) {
      document.body.classList.remove('modal-open');
    }
  }

  findBackdropModalCount(): number {
    return this.modalComponentRefs.filter(
      ref => ref.instance.settings.hasBackdrop
    ).length;
  }
}

export class ScaffoldSidebarRef {
  constructor(
    private modalComponentRef: ComponentRef<ScaffoldSidebarFrameComponent>,
    private scaffoldSidebarService: ScaffoldSidebarService
  ) {
    this.onClose = new Subject<any>();
    this.modalComponentRef.instance.closed.subscribe(() => {
      this.close(null);
    });
  }
  settings: any;
  close(result?: any): void {
    this.onClose.next(result);
    this.onClose.complete();
    this.scaffoldSidebarService.close(this.modalComponentRef);
  }
  onClose: Subject<any>;
  componentRef: ComponentRef<any>;
}
